import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getToken } from '@/utils/auth';
export default {
  name: 'FileUpload',
  props: {
    url: {
      type: String,
      default: function _default() {
        return '/ie/manage/common/uploadFile';
      }
    },
    type: {
      type: String,
      require: true
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      } // [{{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/'}]
    },

    accept: {
      type: String,
      default: ''
    },
    maxSize: {
      type: Number,
      default: 100
    },
    formatText: {
      type: String,
      default: ''
    },
    uploadText: {
      type: String,
      default: '请把文件拖到这里，进行上传'
    },
    multiple: {
      // 是否支持多个文件上传
      type: Boolean,
      default: false
    },
    limit: {
      // 多个文件上传限制数量
      type: Number,
      default: 10
    },
    showFile: {
      type: Boolean,
      default: false
    },
    uploadData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      uploadFiles: [],
      headers: {
        Authorization: "bearer ".concat(getToken())
      }
    };
  },
  created: function created() {},
  methods: {
    beforeUploadCallback: function beforeUploadCallback(file) {
      if (!this.beforeUploadCheckNameLength(file)) return false;
      if (!this.uploadCheckAccept(this.accept)(file)) return false;
      if (!this.beforeUploadCheckSize(file)) return false;
      return true;
    },
    beforeUploadCheckSize: function beforeUploadCheckSize(file) {
      var isLt2M = file.size / 1024 / 1024 <= this.maxSize;
      if (!isLt2M) {
        this.$message({
          message: this.$t("\u4E0A\u4F20\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ".concat(this.maxSize, "MB!"), {
            maxSize: this.maxSize
          }),
          type: 'warning'
        });
      }
      return isLt2M;
    },
    beforeUploadCheckNameLength: function beforeUploadCheckNameLength(file) {
      var isLt2M = file.name.length <= 200;
      if (!isLt2M) {
        this.$message({
          message: '文件名超长，只允许200个字符以内的文件名称',
          type: 'warning'
        });
      }
      return isLt2M;
    },
    uploadCheckAccept: function uploadCheckAccept(accept) {
      var _this = this;
      return function (file) {
        if (!accept) {
          return true;
        }
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        var extension = accept.split(',').includes(".".concat(testmsg));
        if (!extension) {
          _this.$message({
            message: "\u4E0A\u4F20\u6587\u4EF6\u53EA\u80FD\u662F".concat(accept, "\u683C\u5F0F!"),
            type: 'warning'
          });
        }
        return extension;
      };
    },
    clearFiles: function clearFiles() {
      this.$refs.fileUpload.clearFiles();
      this.uploadFiles = [];
    },
    uploadRemove: function uploadRemove(file, fileList) {
      this.changeLoadingStatus(fileList);
    },
    uploadSuccess: function uploadSuccess(response, file, fileList) {
      if (response.code !== '0000000000') {
        fileList.splice(fileList.indexOf(file), 1);
        if (response.code === '700') {
          // 上传成功，但上传文件数据有误
          this.$emit('uploadError', response);
        } else {
          this.$message({
            type: 'error',
            message: response.message || "\u6587\u4EF6\u3010".concat(file.name, "\u3011\u4E0A\u4F20\u5931\u8D25, \u8BF7\u7A0D\u540E\u518D\u8BD5")
          });
        }
      } else {
        this.$emit('uploadSuccess', this.uploadFiles);
      }
    },
    uploadProgress: function uploadProgress(event, file, fileList) {
      var _this2 = this;
      fileList.forEach(function (element, index) {
        if (element.uid === file.uid) {
          var progress = Math.floor(event.percent);
          element.progress = progress === 100 ? 99 : progress;
          _this2.$set(fileList, index, element);
        }
      });
    },
    uploadChange: function uploadChange(file, fileList) {
      var _this3 = this;
      var a = 0;
      fileList.forEach(function (ele, index) {
        if (file.name === ele.name) {
          a++;
          if (a === 2) {
            fileList.splice(index, 1);
          }
        }
      });
      this.uploadFiles = fileList;
      if (file.percentage === 100) {
        setTimeout(function () {
          _this3.$set(file, 'hideProgress', true);
        }, 500);
      }

      // if (file.status === 'success' && file.response.code === '200') {
      //   setTimeout(() => {
      //     this.$set(file, 'percentage', 100)
      //     this.$set(file, 'hideProgress', true)
      //   }, 500)
      // }

      this.changeLoadingStatus(fileList);
    },
    changeLoadingStatus: function changeLoadingStatus(fileList) {
      var isLoading = fileList.some(function (item) {
        return ['ready', 'uploading'].includes(item.status);
      });
      this.$emit('changeLoadingStatus', isLoading);
    },
    uploadError: function uploadError(err, file) {
      this.$notify.error({
        title: '错误',
        message: err.message || "\u6587\u4EF6\u3010".concat(file.name, "\u3011\u4E0A\u4F20\u5931\u8D25, \u8BF7\u7A0D\u540E\u518D\u8BD5")
      });
    },
    removeFile: function removeFile(index) {
      this.uploadFiles.splice(index, 1);
      this.changeLoadingStatus(this.uploadFiles);
    },
    getFileIcon: function getFileIcon(name) {
      var suffixName = this.getFileSuffixName(name);
      if (['doc', 'docx'].includes(suffixName)) {
        return 'word';
      } else if (suffixName === 'pdf') {
        return 'pdf';
      } else {
        return 'common';
      }
    },
    /* 获取文件后缀 */getFileSuffixName: function getFileSuffixName(fileName) {
      var index = fileName.lastIndexOf('.');
      return fileName.substr(index + 1);
    }
  }
};